import UserStore from './user_store';

import util from '../tools/util';

export default {
  checkUploadList,
  addS3Object,
  createMultipart,
  completeMultipart,
};

function checkUploadList(params, done) {
  const opts = {
    url: `/api/1/volume/${params.volume_id}/upload`,
    body: {
      file_list: params.file_list,
    },
    retry: true,
  };
  UserStore.post(opts, (err, body) => {
    if (err) {
      util.errorLog('DeviceHashStore.checkUploadList: err:', err);
    }
    done(err, body?.upload_list);
  });
}
function addS3Object(params, done) {
  const opts = {
    url: `/api/1/volume/${params.volume_id}/s3_object`,
    body: {
      s3_bucket_id: params.s3_bucket_id,
      file_hash: params.file_hash,
      file_size: params.file_size,
    },
    retry: true,
  };
  UserStore.post(opts, (err, body) => {
    if (err) {
      util.errorLog(
        'DeviceHashStore.addS3Object: put object err:',
        err,
        body,
        params.file_hash
      );
    }
    done(err);
  });
}
function createMultipart(params, done) {
  const opts = {
    url: `/api/1/volume/${params.volume_id}/multipart`,
    body: {
      file_hash: params.file_hash,
      file_size: params.file_size,
      part_list: params.part_list,
    },
    retry: true,
  };
  UserStore.post(opts, (err, body) => {
    if (err) {
      util.errorLog('DeviceHashStore.createMultipart: err:', err);
    }
    done(err, body);
  });
}
function completeMultipart(params, done) {
  const opts = {
    url: `/api/1/volume/${params.volume_id}/multipart_complete`,
    body: {
      file_hash: params.file_hash,
      file_size: params.file_size,
      part_list: params.part_list,
      upload_id: params.upload_id,
      s3_bucket_id: params.s3_bucket_id,
    },
    retry: true,
  };
  UserStore.post(opts, (err, body) => {
    if (err) {
      util.errorLog('DeviceHashStore.completeMultipart: err:', err);
    }
    done(err, body);
  });
}
